import HelperClassesContainer from "../../Componant/Ui-Kits/HelperClasses/HelperClasses"


const HelperClasses = () => {
  return (
    <div className='page-body'>
        <HelperClassesContainer />
    </div>
  )
}

export default HelperClasses